import React from 'react';
import Header from './Header';
import Hero from './Hero';
import Services from './Services';
import About from './About';
import QualityFeatures from './QualityFeatures';
import Industries from './Industries';
import Testimonials from './Testimonials';
import Stats from './Stats';
import Footer from './Footer';

const Home = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <Hero />
      <Services />
      <About />
      <QualityFeatures />
      <Industries />
      <Testimonials />
      <Stats />
      <Footer />
    </div>
  );
};

export default Home;